import React from 'react';
import './DateTimeInput.css';

// Convert Date object to "YYYY-MM-DD" string for <input type="date">
const toInputValue = (date) => {
    if (!date || !(date instanceof Date) || isNaN(date)) return '';
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
};

// Convert "YYYY-MM-DD" string to min attribute value
const toMinValue = (date) => {
    if (!date || !(date instanceof Date) || isNaN(date)) return undefined;
    return toInputValue(date);
};

const DatePickerInput = ({
    selected,
    onChange,
    minDate,
    placeholder = 'Select date',
    isInvalid = false,
}) => {
    const handleChange = (e) => {
        const val = e.target.value;
        if (!val) {
            onChange(null);
            return;
        }
        // Parse "YYYY-MM-DD" into a local Date
        const [y, m, d] = val.split('-').map(Number);
        const date = new Date(y, m - 1, d);
        onChange(date);
    };

    return (
        <input
            type="date"
            value={toInputValue(selected)}
            onChange={handleChange}
            min={toMinValue(minDate)}
            placeholder={placeholder}
            className={`project-form-input ${isInvalid ? 'error' : ''}`}
        />
    );
};

export default DatePickerInput;
